import { watchDeleteSalesDocument } from './deleteSalesDocument';
import { watchFetchFiles } from './fetchFiles';
import { watchFetchSalesDocuments } from './fetchSalesDocuments';
import { watchRenameFile } from './RenameFile';
import { watchSetSalesDocumentPermission } from './setSalesDocumentPermissions';
import { watchUploadFile } from './uploadRequest';

export const filesSagas = [
  watchDeleteSalesDocument(),
  watchFetchFiles(),
  watchFetchSalesDocuments(),
  watchRenameFile(),
  watchSetSalesDocumentPermission(),
  watchUploadFile()
];
